// Read-through offline cache for GET requests. Successful JSON GETs are stored in
// IndexedDB; when a GET fails with no response (offline) the last cached value is
// returned so already-visited screens (customers, invoices, records) still render.
const DB_NAME = "amscale-apicache";
const STORE = "kv";

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => { if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE); };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export const cacheKey = (cfg) => `${(cfg.method || "get").toLowerCase()}:${cfg.url || ""}:${cfg.params ? JSON.stringify(cfg.params) : ""}`;

const cacheable = (cfg) =>
  cfg && (cfg.method || "get").toLowerCase() === "get" && !["blob", "arraybuffer"].includes(cfg.responseType);

export async function writeCache(key, value) {
  try {
    const db = await openDB();
    await new Promise((resolve, reject) => {
      const t = db.transaction(STORE, "readwrite");
      t.objectStore(STORE).put(value, key);
      t.oncomplete = () => resolve();
      t.onerror = () => reject(t.error);
    });
  } catch { /* cache is best-effort */ }
}

export function readCache(key) {
  return new Promise(async (resolve) => {
    try {
      const db = await openDB();
      const req = db.transaction(STORE, "readonly").objectStore(STORE).get(key);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => resolve(undefined);
    } catch { resolve(undefined); }
  });
}

// Store a successful GET response.
export function cacheResponse(response) {
  const cfg = response?.config || {};
  if (cacheable(cfg)) writeCache(cacheKey(cfg), response.data);
  return response;
}

// On a network error for a cacheable GET, resolve with the cached value if present.
export async function cacheFallback(error) {
  const cfg = error?.config;
  if (!error?.response && cacheable(cfg)) {
    const cached = await readCache(cacheKey(cfg));
    if (cached !== undefined) {
      window.dispatchEvent(new Event("offline:served"));
      return { data: cached, status: 200, statusText: "OK (offline cache)", headers: {}, config: cfg, cached: true };
    }
  }
  return undefined;
}
